import React, { FC, ReactNode } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Section from 'components/Section';
import PassengerTableRow from 'components/PassengerTableRow';

import { OrderEditMainPassengers_order$key } from '__generated__/OrderEditMainPassengers_order.graphql';

type Props = {
  order: OrderEditMainPassengers_order$key;
};

const OrderEditMainPassengers: FC<Props> = ({ order }) => {
  const { orderRooms } = useFragment(
    graphql`
      fragment OrderEditMainPassengers_order on Order {
        orderRooms {
          slots {
            passenger {
              id
              roomPrice
              ...PassengerTableRow_passenger
            }
          }

          ...PassengerTableRow_orderRoom
        }
      }
    `,
    order
  );

  let rows: ReactNode[] = [];
  let totalPrice = 0;
  orderRooms.forEach(orderRoom => {
    orderRoom.slots.forEach(({ passenger }) => {
      if (passenger) {
        totalPrice += passenger.roomPrice ?? 0;

        rows.push(
          <PassengerTableRow
            key={passenger.id}
            orderRoom={orderRoom}
            passenger={passenger}
          />
        );
      }
    });
  });

  return (
    <Section id="passengers" title="Keliautojai">
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Kambarys</TableCell>
              <TableCell align="center">Vardas, pavardė</TableCell>
              <TableCell align="center">Gimimo data</TableCell>
              <TableCell align="center">Amžius grįžimo dieną</TableCell>
              <TableCell align="center">Kaina</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rows}

            <TableRow>
              <TableCell colSpan={3} />
              <TableCell align="center">Viso</TableCell>
              <TableCell align="center">€{totalPrice}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Section>
  );
};

export default OrderEditMainPassengers;
